import {Component} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Dispatch} from 'redux';
import {LocationDescriptorObject} from 'history';
import {push} from 'connected-react-router';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons';
import {getReportName, ReportCatalog, ReportCatalogEntry, ReportType} from '../../report-catalog';
import styles from './enhanced-invoice-item-by-vehicle-report.module.scss';
import PageHeader from '../../../../components/page-header/page-header';
import {RouteUrl} from '../../../../routes';
import {ApplicationState} from '../../../../store';
import * as layoutActions from '../../../../store/layout/actions';
import {FleetCustomerWithConfiguration} from '../../../../store/fleet-customers';
import {FleetCustomerMatchParameters} from '../../../../types/fleet-customer';
import {
    fetchEnhancedInvoiceItemByVehicleReportRequest,
    EnhancedInvoiceItemByVehicleCustomReportParameters,
    EnhancedInvoiceItemByVehicleReportRequest,
    ReportPeriodType,
} from '../../../../store/reports';
import {endOfDay, forceDateToBrusselsTime, startOfDay} from '../../../../utils/date-helper';
import {FunctionalLocationsSelectionsControlValue} from '../../../analytics/dashboard-controls/functional-locations-selector/types/functional-locations-selections-control-value';
import {FileType, RequestStatus} from '../../../../store/shared/types';
import EnhancedInvoiceItemByVehicleComponent
    from '../../report-scheduler/popup/report-data-components/enhanced-invoice-item-by-vehicle/enhanced-invoice-item-by-vehicle.component';

class EnhancedInvoiceItemByVehicleReportPage extends Component<AllProps, AllState> {

    constructor(props) {
        super(props);
        const {dispatchToggleSidebar} = this.props;
        dispatchToggleSidebar(true);

        this.state = {};
    }

    public render(): JSX.Element {
        const {t, location, reportRequestStatus, fleetCustomer} = this.props;
        const {fromDate, toDate, functionalLocationSelection} = this.state;
        const report: ReportCatalogEntry = new ReportCatalog().getCatalogEntry(ReportType.EnhancedInvoiceItemByVehicle);

        const isValid = functionalLocationSelection && functionalLocationSelection.value.length > 0 && fromDate && toDate;

        return (
            <div className={styles.pageContainer}>
                <PageHeader headerTitle={getReportName(report.type,t)} location={location} bottomComponent={<div/>}/>
                <div className={styles.pageContent}>
                    <EnhancedInvoiceItemByVehicleComponent
                        periodType={ReportPeriodType.Custom}
                        fleetCustomer={fleetCustomer}
                        onCustomParametersChanged={(p) => this.onParametersChanged(p)}
                        onScheduledParametersChanged={() => {}}
                    />
                    <div className={styles.buttons}>
                        <button type='button'
                                className={`${styles.button} ${styles.isNegative}`}
                                disabled={reportRequestStatus?.isInProgress}
                                onClick={() => this.goBack()}>
                            {t('Back')}
                        </button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.ZIP)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download ZIP')}</button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.XLSX)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download XLSX')}</button>
                    </div>
                </div>
            </div>
        );
    }

    private onParametersChanged(parameters: EnhancedInvoiceItemByVehicleCustomReportParameters) {
        this.setState({
            functionalLocationSelection: parameters.functionalLocationSelection,
            fromDate: parameters.fromDate,
            toDate: parameters.toDate,
        });
    }

    private download(fileType:FileType) {
        const {fromDate, toDate, functionalLocationSelection} = this.state;
        const {dispatchFetchEnhancedInvoiceItemByVehicleReport} = this.props
        if (functionalLocationSelection && functionalLocationSelection.value.length > 0 && fromDate && toDate) {
            const request: EnhancedInvoiceItemByVehicleReportRequest = {
                fileType,
                locations: functionalLocationSelection.value,
                fromDate: forceDateToBrusselsTime(startOfDay(fromDate)).toISOString(),
                toDate: forceDateToBrusselsTime(endOfDay(toDate)).toISOString(),
            }

            dispatchFetchEnhancedInvoiceItemByVehicleReport(request);
        }
    }

    private goBack(): void {
        const {dispatchNavigateTo, fleetCustomer} = this.props;
        dispatchNavigateTo({pathname: `/${fleetCustomer?.id}${RouteUrl.Reports}`});
    }
}

// eslint-disable-next-line
const mapStateToProps = ({authentication, reports, fleetCustomers}: ApplicationState) => ({
    fleetCustomer: authentication.fleetCustomer,
    reportRequestStatus: reports.enhancedInvoiceItemByVehicleRequestStatus,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    dispatchToggleSidebar: (showSidebar: boolean) => dispatch(layoutActions.toggleSidebar(showSidebar)),
    dispatchNavigateTo: (location: LocationDescriptorObject) => dispatch(push(location)),
    dispatchFetchEnhancedInvoiceItemByVehicleReport: (request: EnhancedInvoiceItemByVehicleReportRequest) => dispatch(fetchEnhancedInvoiceItemByVehicleReportRequest(request)),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EnhancedInvoiceItemByVehicleReportPage));

interface PropsFromState {
    fleetCustomer?: FleetCustomerWithConfiguration;
    reportRequestStatus: RequestStatus;
}

interface PropsFromDispatch {
    dispatchNavigateTo: typeof push;
    dispatchToggleSidebar: typeof layoutActions.toggleSidebar;
    dispatchFetchEnhancedInvoiceItemByVehicleReport: typeof fetchEnhancedInvoiceItemByVehicleReportRequest;
}

interface OwnProps {
    location: Location;
}

type AllProps = PropsFromState &
    PropsFromDispatch &
    WithTranslation &
    OwnProps &
    RouteComponentProps<FleetCustomerMatchParameters>;

interface OwnState {
    fromDate?: Date;
    toDate?: Date;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

type AllState = OwnState;
